/* Carry the current PDP selection through a normal, shareable navigation URL. */
document.addEventListener('click',event=>{
 const link=event.target.closest?.('a.ev-setup-pdp[data-ev-setup-entry]');if(!link)return;
 const scope=link.closest('.product-info');
 const field=scope?.querySelector('input[name="id"][value]');
 const variant=field?.value||new URL(location.href).searchParams.get('variant');
 const choices=[...(scope?.querySelectorAll('input[data-option-position]:checked')||[])].map(input=>({position:Number(input.dataset.optionPosition),value:input.getAttribute('aria-label')})).filter(option=>option.position>=1&&option.position<=3&&option.value);
 const model=choices.find(option=>/^(iPhone|Samsung|Galaxy) /i.test(option.value))?.value;
 const url=new URL(link.href,location.href);
 if(/^\d+$/.test(variant||''))url.searchParams.set('setup_variant',variant);
 if(model)url.searchParams.set('setup_model',model);
 if(choices.length)url.searchParams.set('setup_options',JSON.stringify(choices));
 link.href=url.href;
},{capture:true});
